const constants = {
    AGENCYIQ: 'AgencyIQ',
    DONNA: 'Donna',
};

export default constants;